export default __webpack_public_path__ + "static/media/SDG_WHITE_logo.e32f6cd2.png";